import React from 'react';
import { IconContainer } from './IconContainer';

const CollapseIcon = (props) => {
    return (
        <IconContainer ariaLabel="collapse" {...props}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.05 12.364L18 7.41401L16.586 6.00001L10.222 12.364L16.586 18.728L18 17.314L13.05 12.364Z" fill="currentColor"/>
                <path d="M7.04983 12.364L11.9998 7.414L10.5858 6L4.22183 12.364L10.5858 18.728L11.9998 17.314L7.04983 12.364Z" fill="currentColor"/>
            </svg>
        </IconContainer>
    )
}

export { CollapseIcon };